import React from 'react'
import pick from 'lodash/pick'
import PropTypes from 'prop-types'

const propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
}

const Chart = React.forwardRef((props, ref) => (
  <svg ref={ref} {...pick(props, Object.keys(propTypes))} />
))

Chart.propTypes = propTypes

export default Chart
